import { render, staticRenderFns } from "./ProductionReconciliationFormInputFieldsInfo.vue?vue&type=template&id=2b686988&scoped=true&"
import script from "./ProductionReconciliationFormInputFieldsInfo.vue?vue&type=script&lang=js&"
export * from "./ProductionReconciliationFormInputFieldsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b686988",
  null
  
)

export default component.exports